// Fades in any element with class="reveal" once it scrolls into view.
// Add the class to an element in the page HTML to opt it in — no extra wiring needed.
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    const targets = document.querySelectorAll(".reveal");
    if (!targets.length) return;
    if (!("IntersectionObserver" in window)) {
      targets.forEach(el => el.classList.add("is-visible"));
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2, rootMargin: "0px 0px -60px 0px" });
    targets.forEach(el => observer.observe(el));
  });
})();
